/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkResult
 */
export interface BulkResult {
    /**
     * 
     * @type {number}
     * @memberof BulkResult
     */
    success?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkResult
     */
    failed?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkResult
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkResult
     */
    id?: number;
}

/**
 * Check if a given object implements the BulkResult interface.
 */
export function instanceOfBulkResult(value: object): value is BulkResult {
    return true;
}

export function BulkResultFromJSON(json: any): BulkResult {
    return BulkResultFromJSONTyped(json, false);
}

export function BulkResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkResult {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'failed': json['failed'] == null ? undefined : json['failed'],
        'total': json['total'] == null ? undefined : json['total'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function BulkResultToJSON(json: any): BulkResult {
    return BulkResultToJSONTyped(json, false);
}

export function BulkResultToJSONTyped(value?: BulkResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'failed': value['failed'],
        'total': value['total'],
        'id': value['id'],
    };
}

